import { t } from 'ttag'

import {
  START_LOADING,
  STOP_LOADING,
  TOP_DEMAND_DATA_LOADED,
  TOP_EMPLOYMENT_DATA_LOADED,
  TOP_WAGE_DATA_LOADED,
  UPDATE_TOP_QCEW_FILTER
} from '../../actions/industry'
import * as h2Api from '../../h2Api'

const initialState = {
  listing: [],
  loading: false,
  filter: {
    type: 0,
    numToDisplay: 10,
    additional: []
  }
}
const reducers = (state = initialState, action) => {
  switch (action.type) {
    case START_LOADING:
      return {
        ...state,
        loading: true
      }

    case STOP_LOADING:
      return {
        ...state,
        loading: false
      }

    case TOP_EMPLOYMENT_DATA_LOADED:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        const p = action.restCall.result

        return {
          ...state,
          listing: p.industries,
          filter: {
            ...state.filter,
            type: 1,
            additional: []
          }
        }
      }

      return state

    case TOP_WAGE_DATA_LOADED:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        const p = action.restCall.result

        return {
          ...state,
          listing: p.industries,
          filter: {
            ...state.filter,
            type: 2,
            additional: []
          }
        }
      }

      return state

    case TOP_DEMAND_DATA_LOADED:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        const p = action.restCall.result

        return {
          ...state,
          listing: p.industries,
          filter: {
            ...state.filter,
            type: 3,
            additional: [
              {
                id: 'tagName',
                name: t`Sector`,
                items: p.flags
              }
            ]
          }
        }
      }

      return state

    case UPDATE_TOP_QCEW_FILTER:
      return {
        ...state,
        filter: {
          ...state.filter,
          [action.field]: action.value
        }
      }

    default:
      return state
  }
}

export default reducers
